import { Navigate } from 'react-router-dom';

import { useWindowLoaderData } from '../api/windowStore';

// Map order status to subpath for redirects
const ORDER_STATUS_REDIRECT_MAP: Record<string, string> = {
  draft: 'configuration',
  quote_ready: 'review',
  order_placed: 'checkout',
};

const DEFAULT_REDIRECT_PATH = 'configuration';

// Component to handle conditional redirects for order index route
export const ResellerOrderIndexRedirect = () => {
  // useLoaderData() here would read the index route, which has no loader;
  // the order lives on the parent route that useWindowLoaderData targets.
  const order = useWindowLoaderData();
  const redirectPath =
    ORDER_STATUS_REDIRECT_MAP[order?.status || ''] || DEFAULT_REDIRECT_PATH;

  return <Navigate to={redirectPath} replace />;
};
